// extracted by mini-css-extract-plugin
export default {"customDropdown":"Dropdown_customDropdown__MVXy5","header":"Dropdown_header__znQHF","optionsList":"Dropdown_optionsList__BGCtL","imgContainer":"Dropdown_imgContainer__nYzCz"};